import { render } from "./RolesIndex.vue?vue&type=template&id=16197025&scoped=true"
import script from "./RolesIndex.vue?vue&type=script&lang=js"
export * from "./RolesIndex.vue?vue&type=script&lang=js"

import "./RolesIndex.vue?vue&type=style&index=0&id=16197025&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16197025"]])

export default __exports__